import Vue from "vue";
import Moment from "moment";
import VuemomentJS from "vue-momentjs";

const state = {
  surgeries: [],
  surgery: {
    address: "",
    approved: "",
    aptNo: "",
    city: "",
    country: "",
    countryId: "",
    name: "",
    phone: "",
    postcode: "",
    state: "",
    surgeryType: "",
    surgeryTypeId: ""
  },
  surgeryTypes: [],
  totalSurgeries: 0
};

const getters = {};

const actions = {
  LOAD_SURGERY: function({ commit }, payload) {
    return Vue.prototype.$axios
      .get("/surgeries/" + payload.surgeryId)
      .then(response => {
        commit("SET_SURGERY", response.data.surgery);
      });
  },
  LOAD_SURGERIES: function({ commit, rootState }, payload) {
    let approvedQuery =
      payload.approved === 1 || payload.approved === 0
        ? "&approved=" + payload.approved
        : "";
    let activeQuery =
      payload.active === 1 || payload.active === 0
        ? "&active=" + payload.active
        : "";
    let nameQuery =
      payload.name !== undefined && payload.name !== null && payload.name !== ""
        ? "&name=" + payload.name
        : "";
    return Vue.prototype.$axios
      .get(
        "/surgeries?from=" +
          payload.from +
          "&limit=" +
          payload.to +
          nameQuery +
          activeQuery +
          approvedQuery
      )
      .then(response => {
        commit("SET_SURGERIES", response.data.surgeries);
        commit("SET_TOTAL_SURGERIES", response.data.meta.total);
      });
  },
  UPDATE_SURGERY: function({ commit }, payload) {
    return Vue.prototype.$axios.post("/surgeries/" + payload.id, payload);
  },
  LOAD_SURGERY_TYPES: function({ commit, rootState }, payload) {
    return Vue.prototype.$axios
      .get("/surgery_types?from=" + payload.from + "&limit=" + payload.to)
      .then(response => {
        commit("SET_SURGERY_TYPES", response.data.surgeryTypes);
      });
  },
  CREATE_SURGERY: function({ commit }, payload) {
    return Vue.prototype.$axios.post("/surgeries", payload);
  },
  DESTROY_SURGERY: function({ commit }, payload) {
    return Vue.prototype.$axios.delete("/surgeries/" + payload);
  }
};

const mutations = {
  SET_SURGERIES: function(state, payload) {
    state.surgeries = payload;
  },
  SET_TOTAL_SURGERIES: function(state, payload) {
    state.totalSurgeries = payload;
  },
  SET_SURGERY: function(state, payload) {
    state.surgery = payload;
  },
  SET_SURGERY_TYPES: function(state, payload) {
    state.surgeryTypes = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
